import { global } from '../constants'

export const data = {
    services: {
        title: "All services",
        subtitle: "Trusted For Our Services",
        description: "SOURCEHUTS offers a comprehensive range of services designed to meet the needs of your business worldwide.",
        services: [
            {
                image: global.sgallery + "1.jpg",
                title: "Freight Forwarding",
                serial: "01",
                description: "We offer safe, quick, and easy ways to ship products around the world according to your requirements."
            },
            {
                image: global.sgallery + "2.jpg",
                title: "Product Sourcing",
                serial: "02",
                description: "Our service connects you with reliable sellers so that you can get what you need quickly and cheaply."
            },
            {
                image: global.sgallery + "3.jpg",
                title: "Factory Audit",
                serial: "03",
                description: "We make sure the quality of the products, that they meet standards, and that they come from reliable sources."
            },
            {
                image: global.sgallery + "4.jpg",
                title: "Inspection",
                serial: "04",
                description: "We check the quality of the products and make sure our inventory inspection meets your standards."
            },
            {
                image: global.sgallery + "5.jpg",
                title: "Sample Evaluation",
                serial: "05",
                description: "Our customized sample checking service is to make sure they meet your specific needs."
            },
            {
                image: global.sgallery + "6.jpg",
                title: "Photography & Videography",
                serial: "06",
                description: "We aim to make high-quality images and videos that show off your products well. "
            }
        ]
    },

    clients: [
        global.logo + "w1.png",
        global.logo + "w2.png",
        global.logo + "w3.png",
        global.logo + "w4.png",
        global.logo + "w5.png",
        global.logo + "w1.png",
        global.logo + "w2.png",
        global.logo + "w3.png",
        global.logo + "w4.png",
        global.logo + "w5.png"
    ],

    whychoosus: {
        title: "Why Choose Us",
        subtitle: "We Deliver Professional Freight & Cargo Services",
        description: "Thanks to SOURCEHUTS's extensive network and global influence, we offer reliable and affordable services worldwide.",
        branches: "295+",
        since: "2012",
        specifications: [
            "Expertise & Experience:With years of industry experience, we bring unmatched services in freight and logistics services.",
            "Advanced Tools & Technology:We use state-of-the-art technology to improve processes and make sure they are done correctly and quickly.",
            " Quality & Compliance:We have strict quality control and follow all international standards to make you comfortable.",
            " Cost-Effective Solutions:Our focus on efficiency ensures affordable pricing without compromising quality.",
            " Customer-Centric Approach:We prioritize customer happiness by providing personalized service and help at every step of the way.",
        ]
    },

    estimation: {
        background: global.back + "bg-5.jpg",
        title: "Estimation",
        subtitle: "Has a wide range of solutions",
        description: "Estimation offers diverse solutions tailored to a wide range of needs.",
        solutions: [
            {
                serial: "01",
                title: "Real-Time Tracking:",
                subtitle: "It is an advanced tracking technology that lets you monitor and manage your packages at all times."
            },
            {
                serial: "02",
                title: "Multiple Warehouses:",
                subtitle: "With multiple stores placed in strategic places around the world, shipping is faster and more flexible."
            },
            {
                serial: "03",
                title: "End-to-End Service:",
                subtitle: "From cargo inventory inspection to final delivery, everything is managed securely."
            }
        ]
    },

    testimonials: {
        title: "Review & Testimonials",
        subtitle: "What Our Clients Say",
        quotes: [
            {
                quote: "They made a huge difference in our supply chain. Now that there is real-time tracking and more than one central site, everything works so much better. Strongly recommended!",
                name: "Emma Martinez",
                designation: "Client",
                image: global.testim + "pic1.jpg"
            },
            {
                quote: "We've worked with sourcehuts for a while now, and their service has been great. Logistics are a lot easier for us because of good contact and help.",
                name: "Alyson Johnson",
                designation: "Client",
                image: global.testim + "pic2.jpg"
            },
            {
                quote: "SOURCEHUTS has completely changed the way we run our business. They saved us time and money by giving us answers that were specific to our needs.",
                name: "Zhao Lin",
                designation: "Client",
                image: global.testim + "pic3.jpg"
            },
            {
                quote: "I love how well SourceHuts works! Their tracking system keeps me up to date every step of the way, and the fact that they have various warehouse choices has made my operations run much more easily.",
                name: "Li Xiaojun",
                designation: "Client",
                image: global.testim + "pic4.jpg"
            }
        ]
    },

    blogs: {
        title: "Our Blogs",
        subtitle: "Recent news & events",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
        blogs: [
            {
                image: global.blog1 + "bg1.jpg",
                day: "02",
                month: "Aug",
                title: "At the end of the day, going forward, a new normal that has evolved from.",
                description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
            },
            {
                image: global.blog2 + "l-1.jpg",
                day: "08",
                month: "Aug",
                title: "How all this mistaken idea denouncing pleasure and praising pain was.",
                description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
            },
            {
                image: global.blog1 + "bg3.jpg",
                day: "21",
                month: "Aug",
                title: "Going forward, a new normal that has evolved from generation.",
                description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
            }
        ]
    },

    approach: {
        title: "Company Approch",
        subtitle: "Reliable Logistic & Sourcing Solutions",
        yearsOfExperience: "35",
        specifications: [
            {
                icon: global.icons + "c-pic1.png",
                count: "195",
                title: "Professional Staff"
            },
            {
                icon: global.icons + "c-pic2.png",
                count: "250",
                title: "On Time Delievery"
            },
            {
                icon: global.icons + "c-pic3.png",
                count: "350",
                title: "Technology and Media"
            }
        ]
    },

    projects: {
        title: "Projects",
        subtitle: "Featured Projects",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
        projects: [
            {
                image: global.projects + "1.jpg",
                title: "Warehousing, Distrbution",
                subtitle: "Warehouse inventory",
                caption: "Nh-16 Highway Bridge"
            },
            {
                image: global.projects + "2.jpg",
                title: "Logistics, Analytics",
                subtitle: "Minimize Manufacturing",
                caption: "Nh-16 Highway Bridge"
            },
            {
                image: global.projects + "3.jpg",
                title: "Warehousing, Distrbution",
                subtitle: "Warehouse inventory",
                caption: "Nh-16 Highway Bridge"
            },
            {
                image: global.projects + "4.jpg",
                title: "Warehousing, Distrbution",
                subtitle: "Warehouse inventory",
                caption: "Nh-16 Highway Bridge"
            },
            {
                image: global.projects + "5.jpg",
                title: "Logistics, Analytics",
                subtitle: "Minimize Manufacturing",
                caption: "Nh-16 Highway Bridge"
            },
            {
                image: global.projects + "6.jpg",
                title: "Warehousing, Distrbution",
                subtitle: "Warehouse inventory",
                caption: "Nh-16 Highway Bridge"
            }
        ]
    },

    plans: {
        title: "Our Plan",
        subtitle: "The right price for you whoever you are",
        plans: [
            {
                type: "Startup",
                price: "90$",
                benifits: [
                    "Additional",
                    "Warehouing",
                    "Custos Borkerage",
                    "Unlimited Transfer"
                ]
            },
            {
                type: "Standard",
                price: "150$",
                benifits: [
                    "Additional",
                    "Warehouing",
                    "Custos Borkerage",
                    "Unlimited Transfer"
                ]
            },
            {
                type: "Business",
                price: "260$",
                benifits: [
                    "Additional",
                    "Warehouing",
                    "Custos Borkerage",
                    "Unlimited Transfer"
                ]
            }
        ]
    }
}
